<template>
    <div>
        <h4 class="text-slate-800 dark:text-slate-100 text-base font-medium mb-3">
            Redemption Type
        </h4>
        <div class="flex flex-wrap gap-4" v-if="redemptionStep === 1">
            <label
                class="w-full md:w-[31%] gap-2 relative rounded-lg border-2 flex flex-col justify-start p-4 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 transition-colors cursor-pointer"
                :class="{
                    'border-orange-500 hover:border-orange-300':
                        redemptionType.id ===
                        activeRedemption.redemption_type_id,
                    'border-slate-200 dark:border-slate-700 hover:border-slate-400':
                        redemptionType.id !==
                        activeRedemption.redemption_type_id,
                }"
                v-for="redemptionType in redemptionTypes"
                :key="redemptionType.id"
                :id="`hs-redemption-type-${redemptionType.id}`"
            >
                <input
                    type="radio"
                    v-model="activeRedemption.redemption_type_id"
                    :value="redemptionType.id"
                    class="sr-only"
                />
                <div
                    class="w-10 h-10 p-2 bg-white dark:bg-slate-800 rounded-full border border-slate-200 dark:border-slate-700 justify-center items-center"
                >
                    <RedemptionIcon :icon="redemptionType.icon" class="text-slate-500 dark:text-slate-400" />
                </div>
                <h3 class="text-slate-800 dark:text-slate-100 text-base font-medium">
                    {{ redemptionType.name }}
                </h3>
            </label>
        </div>
        <div v-if="tripFormErrors.redemption_type_id" class="mt-2">
            <div class="text-red-500 text-xs flex items-center gap-2" role="alert">
                <div class="flex items-center justify-center">
                    <Icon icon="caution" />
                </div>
                {{ tripFormErrors.redemption_type_id }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
import { useTripsStore } from '@/store/trips';
import Icon from '@/components/ui/icon/icon.vue';
import RedemptionIcon from '@/components/trips/icons.vue';
const tripsStore = useTripsStore();

const { activeRedemption, redemptionTypes, redemptionStep, tripFormErrors } =
    storeToRefs(tripsStore);

// Clear error when a redemption type is selected
watch(() => activeRedemption.value.redemption_type_id, (newValue) => {
    if (newValue && tripFormErrors.value.redemption_type_id) {
        delete tripFormErrors.value.redemption_type_id;
    }
});
</script>
